import type { ComponentProps } from 'react';
import { Text, Tooltip } from '@tiendanube/components';
import type { Icon } from '@tiendanube/icons';
import './SecondaryTooltip.scss';

interface SecondaryTooltipProps {
  icon: Icon;
  tooltipText: string;
  position?: ComponentProps<typeof Tooltip>['position'];
}

function SecondaryTooltip({
  icon,
  tooltipText,
  position,
}: SecondaryTooltipProps): JSX.Element {
  return (
    <div className="stratus--secondary-tooltip">
      <Tooltip labelIcon={icon} position={position}>
        <Text>{tooltipText}</Text>
      </Tooltip>
    </div>
  );
}

export default SecondaryTooltip;
